import React, { useState } from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Image from "mui-image";
import heart from "../../../assets/heart-icon.svg";
import clutch from "../../../assets/clutch-co-logo.svg";
import Slider from "react-slick";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { teamData } from "../../../LocalData/db";

const Team = () => {
  const [teamDatas, setTeamDatas] = useState(teamData);
  // prev & next button custom for react slick plugin

  const PreviousBtn = (props: any) => {
    const { className, onClick } = props;
    return (
      <div className={className} onClick={onClick}>
        <svg width="32" height="25" viewBox="0 0 32 25">
          <path
            fill="#3D3D3D"
            fillRule="evenodd"
            d="M0 12a1.22 1.22 0 0 1 0-.13v-.11a1.25 1.25 0 0 1 0-.13l.05-.1.07-.12.07-.09.08-.1L11 .39a1.3 1.3 0 0 1 1.82 0 1.25 1.25 0 0 1 0 1.79l-8.43 8.56h26.32a1.3 1.3 0 0 1 0 2.59H4.29l8.55 8.55a1.25 1.25 0 0 1 0 1.79 1.3 1.3 0 0 1-1.82 0L.37 13l-.08-.09-.08-.09-.06-.11-.06-.11a1.18 1.18 0 0 1 0-.12 1.22 1.22 0 0 1 0-.12 1.16 1.16 0 0 1 0-.12 1.2 1.2 0 0 1 0-.13L0 12z"
          ></path>
        </svg>
      </div>
    );
  };
  const NextBtn = (props: any) => {
    const { className, onClick } = props;
    return (
      <div className={className} onClick={onClick}>
        <svg width="32" height="25" viewBox="0 0 32 25">
          <path
            fill="#3D3D3D"
            fillRule="evenodd"
            d="M32 12a1.22 1.22 0 0 0 0-.13v-.11a1.25 1.25 0 0 0 0-.13l-.05-.1-.07-.12-.07-.09-.08-.1L21 .39a1.3 1.3 0 0 0-1.82 0 1.25 1.25 0 0 0 0 1.79l8.43 8.56H1.29a1.3 1.3 0 0 0 0 2.59h26.42l-8.55 8.55a1.25 1.25 0 0 0 0 1.79 1.3 1.3 0 0 0 1.82 0L31.63 13l.08-.09.08-.09.06-.11.06-.11a1.18 1.18 0 0 0 0-.12 1.22 1.22 0 0 0 0-.12 1.16 1.16 0 0 0 0-.12 1.2 1.2 0 0 0 0-.13L32 12z"
          ></path>
        </svg>
      </div>
    );
  };
  //slider setting props
  const settings = {
    rows: 2,
    slidesPerRow: 3,
    dots: false,
    speed: 900,
    initialSlide: 1,
    slidesToScroll: 1,
    className: "slider variable-width",
    variableWidth: true,
    nextArrow: <NextBtn />,
    prevArrow: <PreviousBtn />,
    responsive: [
      {
        breakpoint: 1270,
        settings: {
          rows: 2,
          slidesPerRow: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          rows: 2,
          slidesPerRow: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          rows: 2,
          slidesPerRow: 1,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          rows: 2,
          slidesPerRow: 1,
          dots: true,
        },
      },
    ],
  };
  return (
    <section id="teamMember" style={{ backgroundColor: "#fafbff" }}>
      <Container
        maxWidth="lg"
        sx={{ padding: { xs: "40px 0", sm: "40px 0", md: "130px 0" } }}
      >
        <Box sx={{ flexGrow: 1 }}>
          <Grid container>
            <Grid
              item
              xs={12}
              md={12}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexDirection: { xs: "column", sm: "row" },
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  textAlign: "left",
                  marginBottom: 0,
                }}
              >
                People <img src={heart} width="40px" alt="heart" /> us
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Image src={clutch} width="141px" height={41} alt="clutch" />
                <Box sx={{ marginLeft: 2 }}>
                  <Typography
                    variant="h5"
                    sx={{
                      textAlign: "left",
                      marginBottom: 0,
                      paddingBottom: 0,
                    }}
                  >
                    5.0/5.0
                    <span className="rating-star">
                      <span className="star-icon">
                        <svg
                          width="16"
                          height="15"
                          viewBox="0 0 16 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.4416 0.626611L8.44151 0.626472C8.39554 0.547466 8.31264 0.5 8.22267 0.5V0C8.09143 0.000127325 7.96247 0.0342827 7.84837 0.0991316C7.73427 0.163981 7.63894 0.257307 7.57167 0.37L8.4416 0.626611ZM8.4416 0.626611L10.6626 4.44061L10.7735 4.63105L10.9889 4.67768L15.2989 5.61069L15.3011 5.61115C15.3445 5.62035 15.3848 5.64082 15.4178 5.67051C15.4508 5.7002 15.4754 5.73806 15.4892 5.78028C15.5029 5.8225 15.5053 5.8676 15.4961 5.91104C15.4869 5.95449 15.4665 5.99475 15.4368 6.02777L15.4358 6.02883L12.4958 9.31884L12.3488 9.48336L12.3713 9.70286L12.8181 14.0737C12.8182 14.0738 12.8182 14.0739 12.8182 14.0741C12.8225 14.118 12.8153 14.1623 12.7972 14.2026C12.779 14.243 12.7506 14.2779 12.7147 14.3039C12.6788 14.3298 12.6367 14.3459 12.5927 14.3505C12.5486 14.3551 12.5042 14.348 12.4637 14.3301L12.4611 14.3289L8.42312 12.5619L8.22196 12.4739L8.02103 12.5625L3.98903 14.3395L3.98767 14.3401C3.9472 14.358 3.90272 14.3651 3.85867 14.3605C3.81463 14.3559 3.77256 14.3398 3.73668 14.3139C3.7008 14.2879 3.67235 14.253 3.65419 14.2126C3.63609 14.1723 3.62884 14.128 3.63316 14.0841C3.63317 14.084 3.63318 14.0838 3.6332 14.0837L4.08008 9.71184L4.10247 9.49277L3.95597 9.32836L1.01097 6.02336L1.00994 6.02221C0.980347 5.9892 0.959944 5.949 0.950778 5.90562C0.941613 5.86224 0.944006 5.81722 0.95772 5.77506C0.971433 5.7329 0.995984 5.69508 1.02891 5.6654C1.06184 5.63571 1.10199 5.6152 1.14535 5.60592L1.14646 5.60568L5.45646 4.67268L5.67185 4.62605L5.78275 4.43561L8.00204 0.624556M8.4416 0.626611L8.00204 0.624556M8.00204 0.624556C8.02493 0.586863 8.05707 0.555629 8.09543 0.533827C8.13437 0.511698 8.17837 0.500043 8.22316 0.5L8.65959 0.499576L8.65975 0.499576L8.72267 0.499515V0.462932V0.462866V0.19018C8.78162 0.242621 8.83278 0.304728 8.87367 0.375L11.0947 4.189L8.00204 0.624556Z"
                            fill="#FF3C2C"
                            stroke="#FF3C2C"
                          ></path>
                        </svg>
                      </span>
                      <span className="star-icon">
                        <svg
                          width="16"
                          height="15"
                          viewBox="0 0 16 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.4416 0.626611L8.44151 0.626472C8.39554 0.547466 8.31264 0.5 8.22267 0.5V0C8.09143 0.000127325 7.96247 0.0342827 7.84837 0.0991316C7.73427 0.163981 7.63894 0.257307 7.57167 0.37L8.4416 0.626611ZM8.4416 0.626611L10.6626 4.44061L10.7735 4.63105L10.9889 4.67768L15.2989 5.61069L15.3011 5.61115C15.3445 5.62035 15.3848 5.64082 15.4178 5.67051C15.4508 5.7002 15.4754 5.73806 15.4892 5.78028C15.5029 5.8225 15.5053 5.8676 15.4961 5.91104C15.4869 5.95449 15.4665 5.99475 15.4368 6.02777L15.4358 6.02883L12.4958 9.31884L12.3488 9.48336L12.3713 9.70286L12.8181 14.0737C12.8182 14.0738 12.8182 14.0739 12.8182 14.0741C12.8225 14.118 12.8153 14.1623 12.7972 14.2026C12.779 14.243 12.7506 14.2779 12.7147 14.3039C12.6788 14.3298 12.6367 14.3459 12.5927 14.3505C12.5486 14.3551 12.5042 14.348 12.4637 14.3301L12.4611 14.3289L8.42312 12.5619L8.22196 12.4739L8.02103 12.5625L3.98903 14.3395L3.98767 14.3401C3.9472 14.358 3.90272 14.3651 3.85867 14.3605C3.81463 14.3559 3.77256 14.3398 3.73668 14.3139C3.7008 14.2879 3.67235 14.253 3.65419 14.2126C3.63609 14.1723 3.62884 14.128 3.63316 14.0841C3.63317 14.084 3.63318 14.0838 3.6332 14.0837L4.08008 9.71184L4.10247 9.49277L3.95597 9.32836L1.01097 6.02336L1.00994 6.02221C0.980347 5.9892 0.959944 5.949 0.950778 5.90562C0.941613 5.86224 0.944006 5.81722 0.95772 5.77506C0.971433 5.7329 0.995984 5.69508 1.02891 5.6654C1.06184 5.63571 1.10199 5.6152 1.14535 5.60592L1.14646 5.60568L5.45646 4.67268L5.67185 4.62605L5.78275 4.43561L8.00204 0.624556M8.4416 0.626611L8.00204 0.624556M8.00204 0.624556C8.02493 0.586863 8.05707 0.555629 8.09543 0.533827C8.13437 0.511698 8.17837 0.500043 8.22316 0.5L8.65959 0.499576L8.65975 0.499576L8.72267 0.499515V0.462932V0.462866V0.19018C8.78162 0.242621 8.83278 0.304728 8.87367 0.375L11.0947 4.189L8.00204 0.624556Z"
                            fill="#FF3C2C"
                            stroke="#FF3C2C"
                          ></path>
                        </svg>
                      </span>
                      <span className="star-icon">
                        <svg
                          width="16"
                          height="15"
                          viewBox="0 0 16 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.4416 0.626611L8.44151 0.626472C8.39554 0.547466 8.31264 0.5 8.22267 0.5V0C8.09143 0.000127325 7.96247 0.0342827 7.84837 0.0991316C7.73427 0.163981 7.63894 0.257307 7.57167 0.37L8.4416 0.626611ZM8.4416 0.626611L10.6626 4.44061L10.7735 4.63105L10.9889 4.67768L15.2989 5.61069L15.3011 5.61115C15.3445 5.62035 15.3848 5.64082 15.4178 5.67051C15.4508 5.7002 15.4754 5.73806 15.4892 5.78028C15.5029 5.8225 15.5053 5.8676 15.4961 5.91104C15.4869 5.95449 15.4665 5.99475 15.4368 6.02777L15.4358 6.02883L12.4958 9.31884L12.3488 9.48336L12.3713 9.70286L12.8181 14.0737C12.8182 14.0738 12.8182 14.0739 12.8182 14.0741C12.8225 14.118 12.8153 14.1623 12.7972 14.2026C12.779 14.243 12.7506 14.2779 12.7147 14.3039C12.6788 14.3298 12.6367 14.3459 12.5927 14.3505C12.5486 14.3551 12.5042 14.348 12.4637 14.3301L12.4611 14.3289L8.42312 12.5619L8.22196 12.4739L8.02103 12.5625L3.98903 14.3395L3.98767 14.3401C3.9472 14.358 3.90272 14.3651 3.85867 14.3605C3.81463 14.3559 3.77256 14.3398 3.73668 14.3139C3.7008 14.2879 3.67235 14.253 3.65419 14.2126C3.63609 14.1723 3.62884 14.128 3.63316 14.0841C3.63317 14.084 3.63318 14.0838 3.6332 14.0837L4.08008 9.71184L4.10247 9.49277L3.95597 9.32836L1.01097 6.02336L1.00994 6.02221C0.980347 5.9892 0.959944 5.949 0.950778 5.90562C0.941613 5.86224 0.944006 5.81722 0.95772 5.77506C0.971433 5.7329 0.995984 5.69508 1.02891 5.6654C1.06184 5.63571 1.10199 5.6152 1.14535 5.60592L1.14646 5.60568L5.45646 4.67268L5.67185 4.62605L5.78275 4.43561L8.00204 0.624556M8.4416 0.626611L8.00204 0.624556M8.00204 0.624556C8.02493 0.586863 8.05707 0.555629 8.09543 0.533827C8.13437 0.511698 8.17837 0.500043 8.22316 0.5L8.65959 0.499576L8.65975 0.499576L8.72267 0.499515V0.462932V0.462866V0.19018C8.78162 0.242621 8.83278 0.304728 8.87367 0.375L11.0947 4.189L8.00204 0.624556Z"
                            fill="#FF3C2C"
                            stroke="#FF3C2C"
                          ></path>
                        </svg>
                      </span>
                      <span className="star-icon">
                        <svg
                          width="16"
                          height="15"
                          viewBox="0 0 16 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.4416 0.626611L8.44151 0.626472C8.39554 0.547466 8.31264 0.5 8.22267 0.5V0C8.09143 0.000127325 7.96247 0.0342827 7.84837 0.0991316C7.73427 0.163981 7.63894 0.257307 7.57167 0.37L8.4416 0.626611ZM8.4416 0.626611L10.6626 4.44061L10.7735 4.63105L10.9889 4.67768L15.2989 5.61069L15.3011 5.61115C15.3445 5.62035 15.3848 5.64082 15.4178 5.67051C15.4508 5.7002 15.4754 5.73806 15.4892 5.78028C15.5029 5.8225 15.5053 5.8676 15.4961 5.91104C15.4869 5.95449 15.4665 5.99475 15.4368 6.02777L15.4358 6.02883L12.4958 9.31884L12.3488 9.48336L12.3713 9.70286L12.8181 14.0737C12.8182 14.0738 12.8182 14.0739 12.8182 14.0741C12.8225 14.118 12.8153 14.1623 12.7972 14.2026C12.779 14.243 12.7506 14.2779 12.7147 14.3039C12.6788 14.3298 12.6367 14.3459 12.5927 14.3505C12.5486 14.3551 12.5042 14.348 12.4637 14.3301L12.4611 14.3289L8.42312 12.5619L8.22196 12.4739L8.02103 12.5625L3.98903 14.3395L3.98767 14.3401C3.9472 14.358 3.90272 14.3651 3.85867 14.3605C3.81463 14.3559 3.77256 14.3398 3.73668 14.3139C3.7008 14.2879 3.67235 14.253 3.65419 14.2126C3.63609 14.1723 3.62884 14.128 3.63316 14.0841C3.63317 14.084 3.63318 14.0838 3.6332 14.0837L4.08008 9.71184L4.10247 9.49277L3.95597 9.32836L1.01097 6.02336L1.00994 6.02221C0.980347 5.9892 0.959944 5.949 0.950778 5.90562C0.941613 5.86224 0.944006 5.81722 0.95772 5.77506C0.971433 5.7329 0.995984 5.69508 1.02891 5.6654C1.06184 5.63571 1.10199 5.6152 1.14535 5.60592L1.14646 5.60568L5.45646 4.67268L5.67185 4.62605L5.78275 4.43561L8.00204 0.624556M8.4416 0.626611L8.00204 0.624556M8.00204 0.624556C8.02493 0.586863 8.05707 0.555629 8.09543 0.533827C8.13437 0.511698 8.17837 0.500043 8.22316 0.5L8.65959 0.499576L8.65975 0.499576L8.72267 0.499515V0.462932V0.462866V0.19018C8.78162 0.242621 8.83278 0.304728 8.87367 0.375L11.0947 4.189L8.00204 0.624556Z"
                            fill="#FF3C2C"
                            stroke="#FF3C2C"
                          ></path>
                        </svg>
                      </span>
                    </span>
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      textAlign: "left",
                      marginBottom: 0,
                    }}
                  >
                    Based on 26 clients reviews
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
          <Box>
            <Slider {...settings}>
              {teamDatas != null &&
                teamDatas.length > 0 &&
                teamDatas.map((data, i) => (
                  <div data-index={i} key={i} className="sliderWrapperTeam">
                    <Box
                      className="teamSlider"
                      sx={{
                        position: "relative",
                        "&:hover": {
                          "& .testimonial-bg": {
                            height: "calc(100% + 30px)",
                            transition:
                              "all 400ms cubic-bezier(0.2, 0.8, 0.2, 1) 0s",
                          },
                        },
                      }}
                    >
                      <div className="testimonial-bg back-animate"></div>
                      <Card
                        sx={{
                          maxWidth: "94%",
                          "&:hover": {
                            transform: "translate(0px, 15px)",
                            "& .client-info": {
                              bottom: "147px",
                              opacity: 1,
                            },
                          },
                        }}
                        id="cardWrapper"
                      >
                        <CardMedia
                          sx={{ height: 200 }}
                          image={data.img}
                          title="green iguana"
                        />
                        <div className="client-info">
                          <Typography
                            gutterBottom
                            variant="h6"
                            component="div"
                            sx={{ color: "white" }}
                          >
                            {data.name},
                            <br />
                            {data.designation}
                          </Typography>
                        </div>
                        <CardContent>
                          <CardMedia
                            sx={{ height: 34, width: 83 }}
                            image={data.logo}
                            title="green iguana"
                          />
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{
                                color: "rgb(61, 61, 61)",
                                fontSize: "17px",
                                lineHeight: "22px",
                              }}
                            >
                              Simform stands out as a leader in the SaaS app
                              development market.
                            </Typography>
                            <button
                              className="play-pause-buttton"
                              type="button"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="20"
                                viewBox="0 0 16 20"
                              >
                                <g fill="none" fill-rule="evenodd">
                                  <path d="M-12-8h36v36h-36z"></path>
                                  <path
                                    fill="#FFF"
                                    d="M0 2.233v15.534a1.5 1.5 0 0 0 2.305 1.266l12.206-7.768a1.5 1.5 0 0 0 0-2.53L2.305.967A1.5 1.5 0 0 0 0 2.233z"
                                  ></path>
                                </g>
                              </svg>
                            </button>
                          </Box>
                        </CardContent>
                      </Card>
                    </Box>
                  </div>
                ))}
            </Slider>
          </Box>
        </Box>
      </Container>
    </section>
  );
};

export default Team;
